import React from 'react';
import { Col, Row, Card, Table } from 'antd';
import PlotColumn from '../components/PlotColumn';
import PlotPie from '../components/PlotPie';

const columns = [
  {
    title: 'Driver',
    dataIndex: 'driver',
    key: 'driver'
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Start Time',
    dataIndex: 'starttime',
    key: 'starttime',
  },
  {
    title: 'Average',
    dataIndex: 'average',
    key: 'average',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  }
];
const data = [
  {
    key: '1',
    driver: 'John Brown',
    email: 'johnbrown@gmail.com',
    starttime: '29/12/2023 11:27',
    average: '10%',
    status: 'In Progress'
  },
  {
    key: '2',
    driver: 'Jim Green',
    email: 'johnbrown@gmail.com',
    starttime: '29/12/2023 11:27',
    average: '10%',
    status: 'In Progress'
  },
  {
    key: '3',
    driver: 'Joe Black',
    email: 'johnbrown@gmail.com',
    starttime: '29/12/2023 11:27',
    average: '10%',
    status: 'In Progress'
  },
  {
    key: '4',
    driver: 'Edward King',
    email: 'johnbrown@gmail.com',
    starttime: '29/12/2023 11:27',
    average: '10%',
    status: 'In Progress'
  }
];

export default function CourseStats() {
  return (
    <div className='CourseStats PageSingle'>
      <div className="AppContainer">
        <h1 className="title">Driver Safety</h1>
        <Row gutter={[20, 20]}>
          <Col xs={{span: 24, order: 1}} md={{span: 12, order: 1}}>
            <Card bordered={false} className="CardItem">
              <PlotColumn />
            </Card>
          </Col>
          <Col xs={{span: 24, order: 2}} md={{span: 12, order: 2}}>
            <Card bordered={false} className="CardItem">
              <PlotPie />
            </Card>
          </Col>
          <Col xs={{span: 24, order: 3}} md={{span: 24, order: 3}}>
            <Card bordered={false} className="CardItem CardTable">
              <Table columns={columns} dataSource={data} />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}